export const DEFAULT_AVATAR_URL = "/uploads/avatars/default_avatar.jpg";

const AVATAR_CACHE_KEY = "qb_avatar_cache_buster";

const readCacheBuster = (): string | null => {
  try {
    return sessionStorage.getItem(AVATAR_CACHE_KEY);
  } catch {
    return null;
  }
};

export const getAvatarCacheBuster = (): string | null => readCacheBuster();

export const bumpAvatarCacheBuster = (): string => {
  const value = Date.now().toString();
  try {
    sessionStorage.setItem(AVATAR_CACHE_KEY, value);
  } catch {
    // ignore storage errors
  }
  return value;
};

type BuildAvatarUrlOptions = {
  cacheBuster?: string | number | null;
  fallback?: string;
};

export const buildAvatarUrl = (
  url?: string | null,
  { cacheBuster, fallback = DEFAULT_AVATAR_URL }: BuildAvatarUrlOptions = {}
): string => {
  const base = url?.trim() || fallback;
  if (!cacheBuster) return base;
  if (!base.startsWith("/uploads/avatars/")) return base;
  if (base.includes("default_avatar")) return base;
  const separator = base.includes("?") ? "&" : "?";
  return `${base}${separator}v=${encodeURIComponent(String(cacheBuster))}`;
};
